/**
 * space_clouds.ts — ONE rule for whether the volumetric clouds (the mesh
 * field and the post-pass composite) may exist right now (2026-09-10, "make
 * sure that clouds do not spawn in space"). The graphics tier says whether
 * the player WANTS clouds; the space sector says whether there is an
 * atmosphere to hold them. PostModule applies it on every pipeline build
 * (the graphics-menu toggle rebuilds) and SpaceModule on activate / deactivate.
 */
export function cloudsAllowed(cloudsEnabled: boolean, spaceFlight: boolean): boolean {
  return cloudsEnabled && !spaceFlight;
}
